import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'ImportFileIntoGroup'
}

import { useMessage } from 'naive-ui'
import { useGroupStore } from '@/store/group'
import Finder from '@/components/finder'
import type { FinderProps, FinderResponse } from '@/components/finder/types'
import { saveAsFile } from '@teams/common/api'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    file: null,
    autoImport: { type: Boolean, default: true }
  },
  emits: ["close", "cancel", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'cancel'): void
  (e: 'confirm', context): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { file: {
      id: number
      groupId: number
      parentId: number
    }, autoImport: boolean }





const message = useMessage()
const groupStore = useGroupStore()

const finderProps: FinderProps = {
  action: 'save',
  path: {
    name: 'TeamFiles',
    groupid: groupStore.groupId,
    params: {
      tid: groupStore.groupId,
      fid: 0
    }
  },
  file: {
    presets: [
      {
        id: props.file?.id,
        groupid: props.file?.groupId,
        parentid: props.file?.parentId
      }
    ]
  },
  featrues: {
    excludes: ['isLatestUseFolder', 'isShowSearch', '~']
  }
}

const closeCurrentDialog = () => {
  emit('close')
}
const confirm = async (response: FinderResponse) => {
  const [file] = response.files
  if (!file) {
    message.error('No file found from VueFinder.')
  }
  const selectFileId = props.file?.id
  // response.path：将要另存到的目录
  const groupId = response.path.groupid
  const parentId = response.path.id
  const folderName = response.path.text
  const context: { finderType: string; finder: unknown } = {
    finderType: 'outsideGroupFile',
    finder: {
      finder: 'file',
      fid: selectFileId,
      name: file.name,
      parent: {
        tid: groupId,
        fid: parentId,
        name: folderName
      }
    }
  }
  //  选择目录后自动另存文件
  if (props.autoImport) {
    // 导入
    const { data } = await saveAsFile(selectFileId, {
      fileid: selectFileId,
      target_groupid: groupId,
      target_parentid: parentId as number,
      fname: file.name
    })
    // finder返回另存后的文件信息
    context.finder = {
      ftype: 'file',
      fid: data.fileid,
      name: data.fname
    }
  }
  closeCurrentDialog()
  emit('confirm', context)
}

const cancel = () => {
  closeCurrentDialog()
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Finder), _mergeProps({ class: "finder-container" }, finderProps, {
    onConfirm: confirm,
    onCancel: cancel
  }), null, 16))
}
}

})